import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { NotificationTemplate } from '@modules/notifications/notification-template/entities/notification-template.model';

export interface NotificationTemplatePayload {
  id: string;
}

export const NotificationTemplateActions = createActionGroup({
  source: 'NotificationTemplate',
  events: {
    'Load One': props<{ uuid: string }>(),
    'Load One Success': props<{ entity: NotificationTemplate }>(),
    'Load One Failure': props<{ error: unknown }>(),

    'Update': props<{
      uuid: string;
      changes: {
        content?: string;
        displayName?: string;
        fileDto?: {
          filename: string;
          description?: string;
          extension?: string;
          data: string;
        };
      };
    }>(),
    'Update Success': props<{ entity: NotificationTemplate }>(),
    'Update Failure': props<{ error: unknown }>(),
  },
});
